import React from 'react'
import Icon from '../common/components/Icon'

const SearchBar = ({ value, onChange }) =>
	<div className="faq__search-bar">
		<Icon icon="magnifying-glass" />
		<input
			className="faq__input"
			type="text"
			placeholder="Rechercher dans le centre d'aide"
			value={value}
			onChange={onChange}
		/>
	</div>

export default SearchBar



// WEBPACK FOOTER //
// ./src/js/faq/SearchBar.js